import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-liste-carico',
	templateUrl: './liste-carico.component.html',
	styleUrls: ['./liste-carico.component.css']
})
export class ListeCaricoComponent implements OnInit {

	emissioniSync: Subscription;
	emissioni : any[];

	emissioneSelected : string = 'select';

	constructor(
		private dataService : DataService
		) { }

	ngOnInit() {
		this.emissioniSync = this.dataService.emissioni$.subscribe(
			emissioni => {
				this.emissioneSelected = 'select';
				if (emissioni) {
					this.emissioni = emissioni;
				}
				else {
					this.emissioni = [];
				}
			});
	}

}
